"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentUserOrgs = getCurrentUserOrgs;
exports.isSelectedOrgWritable = isSelectedOrgWritable;

var _path = _interopRequireDefault(require("path"));

var _http = require("../../http");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getCurrentUserOrgs(_ref) {
  var config = _ref.config;

  var url = _path.default.join(_http.apiPath, 'user/orgs');

  return (0, _http.get)({
    url: url,
    config: config
  });
}

function isSelectedOrgWritable(_x) {
  return _isSelectedOrgWritable.apply(this, arguments);
}

function _isSelectedOrgWritable() {
  _isSelectedOrgWritable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var org, user, config, teamsUrl, teamsResults, permission, j, isTeamMemberUrl, teamMemberResult, _permission;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            org = _ref2.org, user = _ref2.user, config = _ref2.config;
            teamsUrl = _path.default.join(_http.apiPath, 'orgs/' + org.username + '/teams');
            _context.next = 4;
            return (0, _http.get)({
              url: teamsUrl,
              config: config
            });

          case 4:
            teamsResults = _context.sent;

            if (teamsResults) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", true);

          case 7:
            // https://git.door43.org/api/v1/teams/172/members/cecil.new?access_token=PlaygroundTesting
            // test for membership, looking for something other than "read"
            permission = false;
            j = 0;

          case 9:
            if (!(j < teamsResults.length)) {
              _context.next = 23;
              break;
            }

            isTeamMemberUrl = _path.default.join(_http.apiPath, 'teams/' + teamsResults[j].id + '/members/' + user);
            _context.next = 13;
            return (0, _http.get)({
              url: isTeamMemberUrl,
              config: config
            });

          case 13:
            teamMemberResult = _context.sent;

            if (!(teamMemberResult === null)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("continue", 20);

          case 16:
            _permission = teamsResults[j].permission;

            if (!(_permission !== 'read')) {
              _context.next = 20;
              break;
            }

            permission = true;
            return _context.abrupt("break", 23);

          case 20:
            j++;
            _context.next = 9;
            break;

          case 23:
            return _context.abrupt("return", permission);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _isSelectedOrgWritable.apply(this, arguments);
}